// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-526837cb] .el-dialog{\n  background-color: black;\n}\n[data-v-526837cb] .el-card__header {\n\n  background-color: #909399;\n  padding: 10px 20px;\n}\n.row-card-header-title[data-v-526837cb] {\n  color: white;\n  font-size: 15px;\n}\n", ""]);
